import { createAsyncThunk } from '@reduxjs/toolkit';
import { withDefaultErrorHandling } from '@/store/utils';
import { SurveyAnswerPayload } from '@/api/Survey';
import { RewardStatus } from '@/constants/rewards';
import { RootState } from '@/store/store';
import { setRewardStatus } from './surveySlice';
import api from '@/api/apiSingleton';

export const saveAnswers = createAsyncThunk(
  'survey/saveAnswers',
  withDefaultErrorHandling(async (payload: SurveyAnswerPayload) => {
    const response = await api.survey.saveAnswers(payload);

    return response.data;
  }),
);

export const onCollet = createAsyncThunk<void, number>(
  'survey/onCollet',
  withDefaultErrorHandling(async (rewardId, { dispatch, getState }) => {
    const rewards = (getState() as RootState).survey.rewards;
    const index = rewards.findIndex((r) => r.id === rewardId);

    if (index === -1) return;

    dispatch(setRewardStatus({ id: rewardId, status: RewardStatus.COMPLETED }));

    const next = rewards[index + 1];
    if (next && next.status === RewardStatus.NO_STARTED) {
      await new Promise((resolve) => setTimeout(resolve, 1200));
      dispatch(setRewardStatus({ id: next.id, status: RewardStatus.IN_PROGRESS }));
    }
  }),
);
